import { Types } from '@antv/g2';

export type Animation = false | Types.AnimateOption;
